import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { addressLocation, emailAddress, confirm, thanks, phoneNumber } from './common-steps'

// export const startLead: ScenarioStep = {
//   id: Steps.START_LEAD,
//   group: QuestionGroup.LEAD,
//   question: 'start-lead_question',
//   tip: 'start-lead_tip',
//   type: QuestionType.LEAD,
//   next: Steps.ADDRESS_LOCATION,
//   answers: [
//     {
//       id: 'start',
//       text: 'common_next',
//     },
//   ],
// }

export const thanksLead: ScenarioStep = {
  ...thanks,
  question: 'thanks-lead_question',
  tip: 'thanks-lead_tip',
}

export const addressLocationLead: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.LEAD,
  tip: 'address-location_tip',
  answerPlaceholder: 'address-location-lead_answerPlaceholder',
  next: Steps.PROVIDER_AVAILABILITY,
}

export const emailAddressLead: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.ADDRESS_LOCATION,
  metadata: { grandImage: Images.LEAD_1 },
}

export const confirmLead: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_LEAD,
  group: QuestionGroup.LEAD,
  answerPlaceholder: 'confirm-lead_answerPlaceholder',
  next: Steps.THANKS,
}

export const providerAvailability: ScenarioStep = {
  id: Steps.PROVIDER_AVAILABILITY,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.PROVIDER_AVAILABILITY,
  answers: [
    {
      id: 'continue-with-provider',
      text: 'common_continue',
      next: Steps.FIRST_NAME,
    },
  ],
}

export const phoneNumberLead: ScenarioStep = {
  ...phoneNumber,
  next: Steps.CONFIRM_LEAD,
}
